import {useContext, useEffect} from "react";
import { Context } from "./Context";

export function Selection() {
    const {setQuestions, questions, startVal} = useContext(Context);

    useEffect(() => {
    }, [questions]);

    const handleChange = (stepIdx, itemIdx, value, type) => {
        const newQuestions = [...questions];
        const current = newQuestions[stepIdx + 1][itemIdx].selectVal || [];
        if (startVal) {
            alert("이미 채팅을 시작했습니다")
            return;
        }
        if (type === "radio" || type === "text") {
            newQuestions[stepIdx + 1][itemIdx].selectVal = [value];
        } else if (type === "check") {
            if (current.includes(value)) {
                newQuestions[stepIdx + 1][itemIdx].selectVal = current.filter((v) => v !== value);
            } else {
                newQuestions[stepIdx + 1][itemIdx].selectVal = [...current, value];
            }
        }
        setQuestions(newQuestions);
    };

    return (
        <div id="Selection">
            {questions && //index 0은 3단게 초기 질문이 들어있기에 slice
                questions.slice(1).map((stepItems, stepIdx) => (<div key={stepIdx}>
                    <h1 className="py-4 w-full bg-slate-900 text-white font-bold text-xl px-5">
                        {stepIdx + 1}단계
                    </h1>
                    <ul>
                        {stepItems.map((item, itemIdx) => (
                            <li
                                key={itemIdx}
                                className="flex w-full gap-3 border-b border-black"
                            >
                                <div className="bg-gray-100 py-4 px-8 w-[11rem] text-center border-r border-black">
                                    <h1>{item.problem}</h1>
                                </div>
                                <div className="flex 0 w-full py-4">
                                    {/* Radio */}
                                    {item.type === "radio" &&
                                        item.selections?.map((option, optIdx) => (
                                            <label key={'nwcei'+optIdx} className="mr-4  flex gap-1 items-center">
                                                <input
                                                    type="radio"
                                                    name={`radio-${item.id}`}
                                                    value={option}
                                                    checked={item.selectVal?.[0] === option}
                                                    readOnly={startVal}
                                                    onChange={() => handleChange(stepIdx, itemIdx, option, "radio")}
                                                />
                                                {option}
                                            </label>
                                        ))}
                                    {/* Checkbox */}
                                    {item.type === "check" &&
                                        item.selections?.map((option, optIdx) => (
                                            <label key={optIdx} className="mr-4  h-full flex gap-1 items-center">
                                                <input
                                                    type="checkbox"
                                                    value={option}
                                                    disabled={startVal}
                                                    checked={item.selectVal?.includes(option)}
                                                    className={`h-full`}
                                                    onChange={() =>
                                                        handleChange(stepIdx, itemIdx, option, "check")
                                                }
                                                />
                                                {option}
                                            </label>
                                        ))}
                                    {/* Short Text */}
                                    {item.type === "shortTB" && (
                                        <input
                                            type="text"
                                            className="border px-2 py-1 w-full"
                                            value={item.selectVal?.[0] || ""}
                                            readOnly={startVal}
                                            onChange={(e) =>
                                                handleChange(stepIdx, itemIdx, e.target.value, "text")
                                        }
                                        />
                                    )}
                                    {/* Long Text */}
                                    {item.type === "longTB" && (
                                        <textarea
                                            className="border px-2 py-1 w-full"
                                            rows={4}
                                            value={item.selectVal?.[0] || ""}
                                            readOnly={startVal}
                                            onChange={(e) =>
                                                handleChange(stepIdx, itemIdx, e.target.value, "text")
                                        }
                                        />
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                    </div>)
                )
            }
        </div>
    );
}

